import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-315d4fdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onMousedown"]
const _hoisted_2 = ["innerHTML"]

import { ref, computed } from 'vue'
import Fuse from 'fuse.js'
import { htmlSanitizer } from '@/utils/string'
import { MomentMessageHashtag } from '@/entities/moment'
import Typography from '@/components/Rain/Typography/Typography.vue'
import Loading from '@/components/Loading.vue'
import { pendoTrackEvent } from '@/utils/pendo'
import store from '@/mobile/src/store'

interface Props {
    pendoName: string
    minimumSearchLength?: number
    searchInput: string
    setSearchInput?: (searchString: string) => void
    selectNew?: (hashtag: MomentMessageHashtag) => void
    top: number
    bottom: number
    clearOnNoResults: boolean
    showHashtagModal: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HashtagPickerModal',
  props: {
    pendoName: { default: '' },
    minimumSearchLength: { default: 1 },
    searchInput: { default: '' },
    setSearchInput: { type: Function, default: () => ({}) },
    selectNew: { type: Function, default: () => ({}) },
    top: { default: 0 },
    bottom: { default: 0 },
    clearOnNoResults: { type: Boolean, default: false },
    showHashtagModal: { type: Boolean, default: false }
  },
  emits: ['hashtag-selected'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const availableComposerHashtags = computed(
    () => store.getters['moments/availableComposerHashtags']
)
const loadingHashtags = computed(() => store.getters['moments/loadingHashtags'])

const modalOpened = ref(false)

// Dynamically determines whether to position the modal using top/bottom, whichever gives the most screen height
// If both bottom and top are set, check if it'd make more sense to use top
// Otherwise, if bottom is set, use that
// Otherwise, if top is set, use that
// Otherwise just let it hang out where-ever the absolute positioning allows it
const positionStyle = computed(() => {
    if (props.bottom && props.top) {
        const middle = window.innerHeight / 2
        if (props.top < middle) {
            return { top: props.top + 'px' }
        }
    }
    if (props.bottom) {
        return { bottom: props.bottom + 'px' }
    }
    if (props.top) {
        return { top: props.top + 'px' }
    }
    return {}
})

const onHashTagSelect = (hashtag: MomentMessageHashtag) => {
    props.selectNew(hashtag)
    // Reset search state
    props.setSearchInput('')
    emit('hashtag-selected')
}

const showModal = () => {
    let isOpen = props.searchInput?.length >= props.minimumSearchLength

    if (props.showHashtagModal) {
        isOpen = true
    }

    if (isOpen !== modalOpened.value) {
        pendoTrackEvent(
            `moments-${props.pendoName}-picker-${isOpen ? 'opened' : 'closed'}`
        )
        modalOpened.value = isOpen
    }

    return isOpen
}

const highlightSearchInName = (name: string): string => {
    const searchString = htmlSanitizer(props.searchInput)
    if (searchString === '') {
        return '<strong>#</strong>' + name
    }
    const regex = new RegExp(searchString, 'ygi')
    return name.replace(regex, `<strong>#${searchString}</strong>`)
}

const filteredHashtags = computed(() => {
    if (props.searchInput === '') {
        return availableComposerHashtags.value
    }
    const results = fuse.value.search(props.searchInput)
    if (props.clearOnNoResults && !results.length && showModal()) {
        props.setSearchInput('')
    }
    return results
})

const fuse = computed(() => {
    return new Fuse(availableComposerHashtags.value, {
        keys: ['name'],
        shouldSort: true,
        threshold: 0,
        location: 0,
        distance: 0,
        maxPatternLength: 32,
        minMatchCharLength: props.minimumSearchLength,
    })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (showModal())
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "hashtag-picker-modal",
            style: _normalizeStyle(positionStyle.value)
          }, [
            (loadingHashtags.value)
              ? (_openBlock(), _createBlock(Loading, {
                  key: 0,
                  loading: loadingHashtags.value,
                  transparent: ""
                }, null, 8, ["loading"]))
              : _createCommentVNode("", true),
            (!loadingHashtags.value && !filteredHashtags.value.length)
              ? (_openBlock(), _createBlock(Typography, {
                  key: 1,
                  class: "no-results",
                  variant: "body2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Could not find results for: "),
                    _createElementVNode("strong", null, "#" + _toDisplayString(_ctx.searchInput), 1)
                  ], undefined, true),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredHashtags.value, (hashtag, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "hashtag-item",
                onMousedown: ($event: any) => (onHashTagSelect(hashtag))
              }, [
                _createVNode(Typography, {
                  class: "hashtag-name",
                  variant: "body2"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: highlightSearchInName(hashtag.name)
                    }, null, 8, _hoisted_2)
                  ], undefined, true),
                  _: 2
                }, 1024)
              ], 40, _hoisted_1))
            }), 128))
          ], 4))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}
}

})